import { SharedConstants } from "../../../shared/constants/shared.constants";
export const CANCEL_TEXT = SharedConstants.CANCEL_LABEL;
export const SEND_TEXT = SharedConstants.SEND_LABEL;
export const ERROR_TEXT = "Error when attempting to copy application to clipoard";
export const SUCCESS_TEXT = "Application link has been successfully copied to clipboard";
